
import './App.css';
import Bottom from './componts/Bottom';
import Home from './componts/Home';
import Mission from './componts/Mission';
import Signup from './componts/Signup';
import WhySection from './componts/WhySection';

function App() {
  return (
    <>
      <Home />
      <Mission />
      <WhySection />
      <Bottom />
      {/* <Signup /> */}
    </>
  );
}

export default App;
